/**
 * Cookie Banner
 * 1. Проверяем наличие баннера в DOM — если нет, выходим
 * 2. Проверяем cookie — если есть и не истекло, выходим
 * 3. Показываем баннер, вешаем обработчики
 */

(function () {
    const COOKIE_NAME = 'cookie_consent';
    // согласие действует 15 дней; после — куки нет, баннер показывается снова
    const COOKIE_DAYS = 15;

    // 1. Ищем баннер в разметке
    const banner = document.querySelector('.cookie-banner');
    if (!banner) return;

    // 2. Проверяем cookie
    function getCookie(name) {
        const match = document.cookie
            .split('; ')
            .find(row => row.startsWith(name + '='));
        return match ? match.split('=')[1] : null;
    }

    if (getCookie(COOKIE_NAME) === 'accepted') return;

    // 3. Показываем баннер
    banner.classList.add('cookie-banner--visible');

    // 4. Обработчик кнопки «Принять»
    const acceptBtn = banner.querySelector('.js-cookie-banner__accept');

    if (!acceptBtn) {
        return;
    }

    acceptBtn.addEventListener('click', () => {
        const maxAge = COOKIE_DAYS * 24 * 60 * 60;
        const secure = location.protocol === 'https:' ? '; Secure' : '';

        document.cookie = `${COOKIE_NAME}=accepted; max-age=${maxAge}; path=/; SameSite=Lax${secure}`;

        banner.classList.remove('cookie-banner--visible');
    });
})();
